import QuickSearchContainer from './QuickSearchContainer';

export default QuickSearchContainer;
